// Options for the "What type of work are you looking for?" multi-select on
// the get-in-touch mandatory form. Labels/order match the PRD's Enquiry Flow
// Step 1 spec exactly.
export const WORK_TYPES = [
  { label: "New Home / First-Time Interior", value: "new_home_first_time_interior" },
  { label: "Room upgrade / Renovation", value: "room_upgrade_renovation" },
  { label: "Full-Home Upgrade", value: "full_home_upgrade" },
  { label: "Premium / Luxury Interior work", value: "premium_luxury_interior_work" },
];

// Joins the selected work-type values into a display/API string, e.g. for
// the review screen's "Scope of work" row or the lead-gen payload's
// workScope field.
export function workTypesToLabel(values = []) {
  return values
    .map((value) => WORK_TYPES.find((option) => option.value === value)?.label)
    .filter(Boolean)
    .join(", ");
}
